// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

Vue.prototype.$axios = axios

axios.defaults.baseURL = process.env.BASE_API

Vue.config.productionTip = false

// request拦截器
axios.interceptors.request.use(
  config => {
    // sessionStorage.setItem('access-token', '3_o88h7RQwm7E8HYczzL9tcng73_M2nj')
    const dot = config.url.indexOf('?') > -1 ? '&' : '?'
    // config.url = config.url + dot + 'access-token=123'
    if (sessionStorage.getItem('access-token')) {
      config.url = config.url + dot + 'access-token=' + sessionStorage.getItem('access-token')
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      console.log('xx','xxxx')
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          // VueCookies.remove('access-token')
          sessionStorage.removeItem('access-token')
          router.replace({
            path: '/login',
            query: {redirect: router.currentRoute.fullPath}
          })
      }
    }
    return Promise.reject(error)
  })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js